import { useContext, useState } from 'react';
import {
  Autocomplete,
  MenuItem,
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  createFilterOptions,
} from '@mui/material';

import { getDatabase, push, ref, set } from "firebase/database";
import { AuthContext, stopPropagationForTab } from 'components';
import { Tracking } from 'components/Tracking';
import { useNavigate } from "react-router-dom";

const db = getDatabase();
let filter = createFilterOptions({
  matchFrom: 'start',
});


export const BulkModal = (props) => {
  const { items, onClose } = props;
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [ saving, setSaving ] = useState(false);
  const [value, setValue] = useState("");
  const { accountId, brands, userCreatedBrands, updateItem } = useContext(AuthContext);
  console.log('accountId', accountId)

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    navigate("/products_reload");
    onClose();
  }

  let sortByLabel = (a, b) => {
    if (a.label < b.label) {
      return -1;
    } else if (a.label > b.label) {
      return 1;
    } else {
      return 0;
    }
  }

  const handleSave = () => {
    Tracking.track('Portal - Bulk edit Brand', { items: items.length })
    let bulk_update = []
    items.forEach((item) => {
      bulk_update.push(new Promise((resolve, rejejct) => {
        updateItem(
          item,
          { 'brand': value.id },
          resolve
        )
      }))
    })

    Promise.all(bulk_update).then(() => {
      handleClose()
    })
  }
  
  return (
    <>
      <MenuItem onClick={handleOpen}>
        <div>Brand</div>
      </MenuItem>
      <Dialog onKeyDown={stopPropagationForTab} open={open} onClose={handleClose}>
        <DialogTitle>Set Brand</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Change brand of all of your selected items
          </DialogContentText>
          <Autocomplete
            value={value}
            onChange={(event, value) => { 
              if (!value) return

              // New user brand creation happens here
              if (value.create) {
                const regex = /"([^"]+)"/g;
                const matches = value.label.match(regex);

                if (matches) {
                  const extractedText = matches.map(match => match.replace(/"/g, ''));
                  value.label = extractedText[0].toUpperCase()
                }
                const brandsRef = ref(db, 'userCreatedBrands/' + accountId)
                let newBrand = push(brandsRef)
                set(newBrand, { displayName: value.label })
                value.id = newBrand.key
              }

              setValue(value) 
            }}
            isOptionEqualToValue={(option, value) => {
              return option.label === value
            }}
            groupBy={(option) => option.type}
            options={[
              ...Object.keys(userCreatedBrands).map((e) => ({
                type: 'Personal',
                label: userCreatedBrands?.[e].displayName,
                id: e
              })).sort(sortByLabel),
                ...Object.keys(brands).map((e) => ({
                type: 'All brands',
                label: brands?.[e].displayName,
                id: e
              })).sort(sortByLabel)
              ]}
            renderInput={(params) => <TextField {...params} label="" />}
            filterOptions={(options, params) => {
              const filtered = filter(options, params);
      
              const { inputValue } = params;
              if (inputValue) {
                filtered.unshift({
                  type: 'Create new',
                  label: `Add "${inputValue}"`,
                  create: true
                })
              }
      
              return filtered;
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button disabled={saving} onClick={() => { setSaving(true); setTimeout(handleSave, 200) }}>Save</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}